import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import IconoTitulo from '../UI/IconoTitulo';
import useGetListaURL from '../../hooks/useGetListaURL';
import styles from './UltimoTorneoTipo.module.css';

const UltimoTorneoTipo = (props) => {
  const torneo = props.torneo;
  const [campeon, setCampeon] = useState(null);
  const { fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const obtenerCampeon = (lista) => {
      const listaFiltrada = lista.filter((item) => item.tituloObtenido === 'C');
      if (listaFiltrada && listaFiltrada.length > 0) {
        setCampeon(listaFiltrada[0]);
      } else {
        setCampeon(null);
      }
    };

    if (torneo) {
      fetchData('torneos/' + torneo.id + '/participantes?conTituloObtenido=true', obtenerCampeon);
    } else {
      setCampeon(null);
    }
  }, [torneo, fetchData]);

  return (
    <React.Fragment>
      {torneo && (
        <Link className={`${styles.nombreTorneo}`} to={'/torneos/' + torneo.id}>
          {torneo.descripcion}
        </Link>
      )}
      <div className={`${styles.campeon}`}>
        {campeon && (
          <React.Fragment>
            {campeon.nombre}
            <IconoTitulo objeto={campeon} />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default UltimoTorneoTipo;
